// IntegrationHealthCard.jsx — v119.145 Minimal red/green pill matching
// HealthKpiBar style (per user request v119.145: "just green/red + name").
import React, { useCallback, useEffect, useState } from "react";
import { api } from "./lib/api";

const INTS = [
  { id: "retm",         label: "RETM POS",       nav: "pos" },
  { id: "webhook",      label: "Webhook",        nav: "pos" },
  { id: "whatsapp",     label: "WhatsApp",       nav: "whatsapp" },
  { id: "make",         label: "Make.com",       nav: "make" },
  { id: "malhr",        label: "مَلْحَر HR",      nav: "employees" },
  { id: "emergent_llm", label: "Claude AI",      nav: "ai" },
];

export default function IntegrationHealthCard({ onNavigate }) {
  const [status, setStatus] = useState({});
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const r = await api.get("/integrations/health");
      setStatus(r.data || {});
    } catch { setStatus({}); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => {
    load();
    const t = setInterval(load, 60_000);
    return () => clearInterval(t);
  }, [load]);

  return (
    <div data-testid="integration-health-card" style={{ marginBottom: 16 }}>
      {/* Section header — mirror HealthKpiBar's title style */}
      <div style={{
        fontSize: 14, fontWeight: 800, color: "var(--brown-deep)",
        marginBottom: 8, paddingInlineStart: 8,
        borderInlineStart: "3px solid var(--gold-deep)",
      }}>
        🔌 صحة الأنظمة والربط
      </div>

      {/* Flexible grid of tiny status pills */}
      <div style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))",
        gap: 8,
      }}>
        {INTS.map((it) => {
          const s = status[it.id] || {};
          const ok = !loading && !!s.ok;
          return (
            <button
              key={it.id}
              type="button"
              onClick={() => onNavigate?.(it.nav)}
              data-testid={`ihc-${it.id}`}
              className="tw-clickable"
              style={{
                display: "flex", alignItems: "center", gap: 8,
                background: "#fff",
                border: `1px solid ${ok ? "#bbf7d0" : "#fecaca"}`,
                borderRadius: 10, padding: "8px 10px",
                cursor: "pointer", textAlign: "start",
                boxShadow: "0 1px 2px rgba(0,0,0,0.04)",
              }}
            >
              <span style={{
                display: "inline-block",
                width: 10, height: 10, borderRadius: "50%",
                background: loading ? "#d4d4d4" : (ok ? "#16a34a" : "#dc2626"),
                boxShadow: (!loading && ok) ? "0 0 0 3px rgba(22,163,74,0.15)" : "none",
                flexShrink: 0,
              }} />
              <span style={{
                fontSize: 13, fontWeight: 600,
                color: "var(--brown-deep)",
                whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis",
              }}>{it.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
